<template>
  <div class="services">
    <!-- Hero Section -->
    <section class="bg-bleumarine text-white py-16">
      <div class="container mx-auto px-4">
        <h1 class="text-3xl md:text-4xl font-bold text-center mb-4">Nos Services</h1>
        <p class="text-center text-turquoise max-w-2xl mx-auto">
          Des solutions complètes pour répondre à tous vos besoins en matière de systèmes d'information.
        </p>
      </div>
    </section>

    <!-- Services Grid -->
    <section class="py-16 bg-white">
      <div class="container mx-auto px-4">
        <div class="space-y-16">
          <!-- Datacenter & Productivité -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-bleumarine rounded-lg flex items-center justify-center mr-4">
                <Server class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Datacenter & Productivité d'Entreprise</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in datacenterServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Réseaux & Télécommunications -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-turquoise rounded-lg flex items-center justify-center mr-4">
                <Globe class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Réseaux Informatiques & Télécommunications</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in networkServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Sécurité SI -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-violet rounded-lg flex items-center justify-center mr-4">
                <Shield class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Sécurité des Systèmes d'Information</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in securityServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Développement & Bases de données -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center mr-4">
                <Database class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Développement d'Applications & Bases de Données</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in devServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Audit & Gouvernance -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-bleumarine rounded-lg flex items-center justify-center mr-4">
                <FileText class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Audit & Gouvernance IT</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in auditServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Matériels & Sécurité électronique -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-turquoise rounded-lg flex items-center justify-center mr-4">
                <Wrench class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Matériels Informatiques & Sécurité Électronique</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in hardwareServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>

          <!-- Formations -->
          <div class="service-category">
            <div class="flex items-center mb-6">
              <div class="w-12 h-12 bg-violet rounded-lg flex items-center justify-center mr-4">
                <GraduationCap class="w-6 h-6" style="color: #fff;" />
              </div>
              <h2 class="text-2xl font-bold">Formations Professionnelles IT</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="item in trainingServices" :key="item" class="bg-gray-50 rounded-lg p-4">
                <p class="text-gray-700">{{ item }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-16 bg-gray-50">
      <div class="container mx-auto px-4 text-center">
        <h2 class="text-2xl md:text-3xl font-bold mb-4">Besoin d'un Service Sur Mesure ?</h2>
        <p class="text-gray-600 mb-8 max-w-2xl mx-auto">
          Notre équipe est à votre disposition pour étudier vos besoins et vous proposer des solutions adaptées.
        </p>
        <router-link to="/contact" class="btn-primary inline-block">
          Demander un Devis
        </router-link>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Server, Globe, Shield, Database, FileText, Wrench, GraduationCap } from 'lucide-vue-next'

const datacenterServices = ref([
  'Energie : onduleurs et groupe électrogène',
  'Refroidissement intelligent de Datacenter',
  'Serveurs',
  'Virtualisation de serveurs et d\'applications',
  'Cloud computing : cloud public et cloud privé',
  'Solution de stockage et de sauvegarde',
  'Sécurité physique et logique',
  'Annuaire LDAP d\'entreprise',
  'Messagerie d\'entreprise',
  'Communication et collaboration d\'entreprise',
  'Supervision d\'infrastructure'
])

const networkServices = ref([
  'Fourniture et configuration d\'équipements réseaux : routeurs, switches, points d\'accès',
  'Câblage informatique d\'entreprise',
  'Solution d\'interconnexions réseaux',
  'Solution de VoIP et téléphonie sur IP',
  'Solution de sécurité de réseaux : sécurité de périmètre, conformité'
])

const securityServices = ref([
  'Audit de sécurité',
  'Mise en place de politiques de sécurité',
  'Protection contre les cyberattaques',
  'Gestion des identités et accès',
  'Surveillance et monitoring',
  'Formation à la sécurité'
])

const devServices = ref([
  'Solution intégrée pour entreprise et institutions : ERP/PGI',
  'Développement d\'applications pour tous les métiers de l\'entreprise',
  'Développement d\'applications sur mesure',
  'Développement et hébergement de sites Web',
  'Développement d\'applications Web et de mobile',
  'Implémentation de bases de données sécurisées'
])

const auditServices = ref([
  'Audit de Système d\'Information',
  'Gouvernance de système d\'information',
  'Définition de Politique de Sécurité',
  'Accompagnement à la mise en conformité',
  'Gestion de projet',
  'Assistance à la maîtrise d\'ouvrage',
  'Assistance à la réalisation de documents techniques'
])

const hardwareServices = ref([
  'Fourniture de postes de travail et ordinateurs portables',
  'Tablettes et SmartPhones d\'entreprise',
  'Composants de sécurité électronique : Vidéosurveillance',
  'Contrôle d\'accès',
  'Protection Incendie',
  'Anti-intrusion'
])

const trainingServices = ref([
  'Implémentation de serveurs et d\'infrastructure système',
  'Infrastructure réseaux et télécommunications',
  'Développement d\'applications',
  'Administration de bases de données',
  'Sécurité de système d\'informations',
  'Gestion de projets informatiques',
  'Formations pour le personnel d\'entreprise (bureautique, outils de communication)',
  'Formation personnalisée pour les solutions propres aux différents métiers',
  'Formation individualisée',
  'Formation immersive pour le nouveau personnel et les étudiants'
])
</script>
